import api from '@services/api/server'
import { IListPaginated, IMessage } from '@interfaces/index'
import { ICreateUpdateUser } from '@interfaces/userManagement/ICreateUpdateUser'
import { IUserManagement, USER_STATUS } from '@interfaces/userManagement/IUserManagement'
import { USER_ROLE } from '@interfaces/userManagement/enums/userRole'
import { IUserFilters } from '@interfaces/userManagement/iUserFilters'
import { IUsersName } from '@interfaces/apartments/IApartments'

export default class UserManagementService {
    public static async createUser(values: ICreateUpdateUser): Promise<IMessage> {
        return (await api.post<IMessage>('/users', values)).data
    }
    public static async editUser(id: number, values: ICreateUpdateUser): Promise<IMessage> {
        return (await api.put<IMessage>(`/users/${id}`, values)).data
    }
    public static async getUsersList(page: number, perPage = 25, filters?: IUserFilters): Promise<IListPaginated<IUserManagement>> {
        return (await api.get<IListPaginated<IUserManagement>>('/users', { params: { page: page, perPage: perPage, ...filters } })).data
    }
    public static async getUser(id: number): Promise<IUserManagement> {
        return (await api.get<IUserManagement>(`/users/${id}`)).data
    }
    public static async activeUnactiveUser(id: number, status: USER_STATUS, userRole: USER_ROLE): Promise<IMessage> {
        return (await api.patch<IMessage>(`/users/${id}`, { status: status, userRole: userRole })).data
    }
    public static async getUsersSummary(): Promise<IUsersName[]> {
        return (await api.get<IUsersName[]>('/users/summary')).data
    }
}
